import { store } from "../../store";

import * as api from "./api";
import * as actionCreators from "./actions";

export const revoke = () => store.dispatch(actionCreators.clear());

export const login = ({ email, password }, persist) =>
  api
    .login({ email, password })
    .then(response => {
      store.dispatch(
        actionCreators.update({
          token: response.token,
          persist,
          user: {
            email,
            name: response.name,
            admin: response.admin,
          },
        }),
      );
    })
    .catch(exception => {
      revoke();
      throw exception;
    });
